var GTURolexConsent = localStorage.SeersCMPConsent ? JSON.parse(localStorage.SeersCMPConsent).value : false;
var rolexString = "Rolex (Adobe Analytics and Content Square)";
var consent;

jQueryCode = function(){

    jQuery(document).on("click", '.GTU-CookieSettings', function(event) {
      //cx.buildHTML();  
      id("SeersCMPBannerMainBar").style.display = "flex";            
        // jQuery("#seers-cmp-cookie-policy-default-banner-content").addClass("seers-cmp-cookie-banner-active");
        // jQuery("#seers-cmp-overlay").addClass("seers-cmp-overlay-active");
    });

    jQuery(document).on("click", '.seers-cmp-agree-button', function(event) {
                    
        //document.cookie = `rlx-consent=true; expires=${new Date(new Date().getTime()+1000*60*60*24*365).toGMTString()}; path=/`;
        setCookie('rlx-consent', 'true', {'max-age': 31536000});
        if(document.getElementById("rlx-corner")){
            document.getElementById("rlx-corner").contentWindow.postMessage("consentTrue","https://cornersv7.Rolex.com");
            document.getElementById("rlx-corner").contentWindow.postMessage("consentValidation","https://cornersv7.Rolex.com");
        }
    });

    jQuery(document).on("click", '.seers-cmp-disagree-button', function(event) {
        
        //document.cookie = `rlx-consent=false; expires=${new Date(new Date().getTime()+1000*60*60*24*365).toGMTString()}; path=/`;
        setCookie('rlx-consent', 'false', {'max-age': 31536000});
        if(document.getElementById("rlx-corner")){
            document.getElementById("rlx-corner").contentWindow.postMessage("consentFalse","https://cornersv7.Rolex.com");
        }
    });

    jQuery(document).on("click", '#SeersCMPBannerSavePreferences', function(event) {
        
        
        if(jQuery(`#seers-cmp-cookie-policy-${CSS.escape(rolexString)}-switch`).is(":checked")){
            setCookie('rlx-consent', 'true', {'max-age': 31536000});
        }else{
            setCookie('rlx-consent', 'false', {'max-age': 31536000});
        }
        

        if(document.getElementById("rlx-corner") && jQuery(`#seers-cmp-cookie-policy-${CSS.escape(rolexString)}-switch`).is(":checked")){
            document.getElementById("rlx-corner").contentWindow.postMessage("consentTrue","https://cornersv7.Rolex.com");
            document.getElementById("rlx-corner").contentWindow.postMessage("consentValidation","https://cornersv7.Rolex.com");
        }else if(document.getElementById("rlx-corner") && !jQuery(`#seers-cmp-cookie-policy-${CSS.escape(rolexString)}-switch`).is(":checked")){
            document.getElementById("rlx-corner").contentWindow.postMessage("consentFalse","https://cornersv7.Rolex.com");
        }
    });
    
}

window.addEventListener("load", function () {

  function setRolexMarketingCookie(value) {
    document.cookie =
      "rlx-marketing=" + (value ? "true" : "false") +
      ";path=/;max-age=31536000";
  }

  function updateMarketingCookie() {
    try {
      const consent = JSON.parse(localStorage.getItem("SeersCMPConsent"));

      if (!consent || !consent.value) {
        setRolexMarketingCookie(false);
        return;
      }

      const values = consent.value;

      /*
       * IMPORTANT:
       * Replace "Marketing" below with the exact key
       * stored by Seers once we know its name.
       */
      setRolexMarketingCookie(values["Marketing"] === true);

    } catch (e) {
      setRolexMarketingCookie(false);
    }
  }

  // Initial page load
  updateMarketingCookie();

  // Accept All
  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("seers-cmp-agree-button")) {
      setRolexMarketingCookie(true);
    }
  });

  // Reject All
  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("seers-cmp-disagree-button")) {
      setRolexMarketingCookie(false);
    }
  });

  // Save Preferences
  document.addEventListener("click", function (e) {
    if (e.target.id === "SeersCMPBannerSavePreferences") {
      setTimeout(updateMarketingCookie, 300);
    }
  });

});


if(localStorage.getItem("SeersCMPConsent")){
    consent = JSON.parse(GTURolexConsent);
    //console.log(consent["Rolex (Adobe Analytics and Content Square)"]);
    if(consent["Rolex (Adobe Analytics and Content Square)"]){
        setCookie('rlx-consent', 'true', {'max-age': 31536000});
    }else{
        setCookie('rlx-consent', 'false', {'max-age': 31536000});
    }
}else{
    setCookie('rlx-consent', 'false', {'max-age': 31536000});
}

if(window.jQuery)  jQueryCode();
else{   
    var script = document.createElement('script'); 
    document.head.appendChild(script);  
    script.type = 'text/javascript';
    script.src = "//ajax.googleapis.com/ajax/libs/jquery/3.1.0/jquery.min.js";

    script.onload = jQueryCode;
}

waitForElm(`#seers-cmp-cookie-policy-${CSS.escape(rolexString)}-switch`).then((elm) => {
    
    if(localStorage.getItem("SeersCMPConsent")){
        consent = JSON.parse(GTURolexConsent);
        
        if(consent["Rolex (Adobe Analytics and Content Square)"]){
            elm.checked = true;
        }else{
            elm.checked = false;
        }
    }else{
        elm.checked = false;
    }
});
waitForElm('#SeersCMPBannerSavePreferences').then((elm) => {
    elm.style = "background: #222222 !important; color: #ffffff !important;";
});
waitForElm('.seers-cmp-disagree-button').then((elm) => {
    elm.style = "background: #222222 !important; color: #ffffff !important; width: 200px !important;";
});
waitForElm('.seers-cmp-agree-button').then((elm) => {
    elm.style = "background: #222222 !important; color: #ffffff !important; width: 200px !important;";
});
waitForElm('.seers-cmp-preference-btn').then((elm) => {
    elm.style = "background: #222222 !important; color: #ffffff !important; width: 200px !important;";
});
waitForElm('.seers-cmp-policy-banner-text-links .seers-cmp-agree-button').then((elm) => {
    elm.style = "background: #222222 !important; color: #ffffff !important;";
});
waitForElm('.seers-cmp-policy-banner-text-links .seers-cmp-disagree-button').then((elm) => {
    elm.style = "background: #222222 !important; color: #ffffff !important;";
});

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

function getCookie(name) {
  let matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}


function setCookie(name, value, options = {}) {

  options = {
    path: '/',
    // add other defaults here if necessary
    ...options
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }

  document.cookie = updatedCookie;
}